import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../../config/queryClient'
import { QueryKeys } from '../../../../enums/queryKeys'
import { usePeriodDates } from '../../../../hooks/usePeriodDates'
import { fetchSalesByCustomerReport } from '../../query-api'
import { FetchSalesReportParams } from '../../types/fetchSalesReportParams'
import { getSalesReportDateRange } from '../../utils/getSalesReportDateRange'

interface UseFetchSalesByCustomerReportProps {
  period?: string
}

export const useFetchSalesByCustomerReport = ({ period }: UseFetchSalesByCustomerReportProps) => {
  const { organization } = useUserOrganization()
  const { firstFiscalYearStart } = organization || {}
  const { isLoading: isLoadingPeriodDates, fromDate: startDate, toDate: endDate } = usePeriodDates(period)

  const { startDate: salesReportStartDate, endDate: salesReportEndDate } = useMemo(
    () => getSalesReportDateRange(startDate, endDate, firstFiscalYearStart),
    [startDate, endDate, firstFiscalYearStart],
  )

  const queryParams: FetchSalesReportParams = useMemo(() => {
    return {
      startDate: salesReportStartDate,
      endDate: salesReportEndDate,
    }
  }, [salesReportStartDate, salesReportEndDate])

  const queryKey = useMemo(() => [QueryKeys.DocumentReportsSalesByCustomer, queryParams], [queryParams])

  const { data: salesByCustomerReportData, isLoading: isLoadingSalesReport } = useQuery(
    queryKey,
    () => fetchSalesByCustomerReport(queryParams),
    {
      enabled: !isLoadingPeriodDates,
      staleTime: defaultStaleTime,
    },
  )

  const isLoading = isLoadingPeriodDates || isLoadingSalesReport

  return { isLoading, salesByCustomerReport: salesByCustomerReportData?.data.data || [] }
}
